import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { StatusApprovalsPipe } from '@fuse/pipes/approvals-status/status-translate.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { groupBy, union } from 'lodash';
import { ApprovalsEquipmentsService } from '../../services/approvals-equipments.service';

import english from './../../i18n/en.json';
import spanish from './../../i18n/es.json';
import portuguese from './../../i18n/pt.json';

import { DialogApprovalsEquipmentsApproveComponent } from './../dialog-approvals-approve/dialog-approvals-approve.component';
import { DialogApprovalsEquipmentsRejectComponent } from './../dialog-approvals-reject/dialog-approvals-reject.component';

@Component({
  selector: 'dialog-approvals-equipments',
  templateUrl: './dialog-approvals-equipments.component.html',
  styleUrls: ['./dialog-approvals-equipments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogApprovalsEquipmentsDiffComponent implements OnInit {
  public customFields: Array<any> = [];
  public attachments: Array<any> = [];
  public isExistingNumber = false;

  public isViewMode = !this.authenticationService.hasPermission('approvals-equipments-edit');

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataToDiff: any,
    public matDialogRef: MatDialogRef<DialogApprovalsEquipmentsDiffComponent>,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private approvalsEquipmentsService: ApprovalsEquipmentsService,
    private authenticationService: AuthenticationService,
    private statusApprovalsPipe: StatusApprovalsPipe,
    private translateService: TranslateService,
    private matDialog: MatDialog
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.dataToDiff.approval.equipment.archived = this.dataToDiff.approval.equipment.archived
      ? this.translateService.instant('APPROVALS_EQUIPMENTS.INACTIVE')
      : this.translateService.instant('APPROVALS_EQUIPMENTS.ACTIVE');

    this.dataToDiff.equipment.archived = this.dataToDiff.equipment.archived
      ? this.translateService.instant('APPROVALS_EQUIPMENTS.INACTIVE')
      : this.translateService.instant('APPROVALS_EQUIPMENTS.ACTIVE');

    this.dataToDiff.approval.approvalStatus = this.statusApprovalsPipe.transform(this.dataToDiff.approval.status);

    if (this.dataToDiff.equipment.customFields && this.dataToDiff.equipment.customFields.length) {
      this.dataToDiff.equipment.customFields.forEach((customField) => { customField.status = 'old'; });
      this.dataToDiff.approval.equipment.customFields.forEach((customField) => { customField.status = 'new'; });
      const customFieldsGrouped: any = Object.values(groupBy(union(this.dataToDiff.equipment.customFields, this.dataToDiff.approval.equipment.customFields), 'name'));
      for (const customFields of customFieldsGrouped) {
        if (customFields.length === 1) {
          if (customFields[0].status === 'old') {
            customFields.push({ status: 'new' });
          } else {
            customFields.unshift({ status: 'old' });
          }
        }
      }
      this.customFields = customFieldsGrouped;
    }

    if (
      (this.dataToDiff.equipment.attachments && this.dataToDiff.equipment.attachments.length) ||
      (this.dataToDiff.approval.equipment.attachments && this.dataToDiff.approval.equipment.attachments.length)
    ) {

      this.dataToDiff.equipment.attachments.forEach((attachment) => { attachment.status = 'old'; });
      this.dataToDiff.approval.equipment.attachments.forEach((attachment) => { attachment.status = 'new'; });
      const attachmentsGrouped: any = Object.values(groupBy(union(this.dataToDiff.equipment.attachments, this.dataToDiff.approval.equipment.attachments), 'path'));
      for (const attachments of attachmentsGrouped) {
        if (attachments.length === 1) {
          if (attachments[0].status === 'old') {
            attachments.push({ status: 'new' });
          } else {
            attachments.unshift({ status: 'old' });
          }
        }
      }
      this.attachments = attachmentsGrouped;
    }
  }

  async ngOnInit(): Promise<void> {
    const approvalEquipment = this.dataToDiff.approval.equipment;
    const existingEquipment = await this.approvalsEquipmentsService.searchEquipment(approvalEquipment.number);

    if (existingEquipment && existingEquipment.qrCode !== approvalEquipment.qrCode) {
      this.isExistingNumber = true;
    }
  }

  openApproveDialog(): void {
    const equipmentsApprove = this.matDialog.open(DialogApprovalsEquipmentsApproveComponent, { panelClass: ['dialog-approvals-approve'], data: this.dataToDiff.approval });
    equipmentsApprove.afterClosed().subscribe((reload) => {
      if (reload) { this.matDialogRef.close(true); }
    });
  }

  openRejectDialog(): void {
    const equipmentsReject = this.matDialog.open(DialogApprovalsEquipmentsRejectComponent, { panelClass: ['dialog-approvals-reject'], data: this.dataToDiff.approval });
    equipmentsReject.afterClosed().subscribe((reload) => {
      if (reload) { this.matDialogRef.close(true); }
    });
  }
}
